import type { ReactNode } from 'react';
import ComingSoon from './ComingSoon';

/**
 * 永久權限模型（V55 起）
 * 每個 route 必須屬於以下四種狀態之一：
 *  - PUBLIC        正式公開，匿名訪客可瀏覽。
 *  - COMING_SOON   route 存在，但真正內容不得向匿名訪客輸出。
 *  - LOGIN_REQUIRED 只有登入者可以進入（由頁面自身 AuthGuard/AuthGate 攔截）。
 *  - ROLE_REQUIRED  只有具指定角色／權限者可進入（由頁面自身 AuthGate 攔截）。
 *
 * 預設（default）必須是 COMING_SOON 或 LOGIN_REQUIRED，直到 ABAA 明確批准 PUBLIC。
 */
export type AccessState =
  | 'PUBLIC'
  | 'COMING_SOON'
  | 'LOGIN_REQUIRED'
  | 'ROLE_REQUIRED';

export default function RouteGate({
  access,
  children,
}: {
  access: AccessState;
  children: ReactNode;
}) {
  if (access === 'COMING_SOON') {
    return <ComingSoon />;
  }

  // PUBLIC：直接渲染。
  // LOGIN_REQUIRED / ROLE_REQUIRED：由頁面自身的 AuthGuard / AuthGate 負責攔截，
  // 此處不重複實作，避免與既有登入／角色機制衝突。
  return <>{children}</>;
}